import { put, call, cancelled, takeEvery } from 'redux-saga/effects';

import { request } from './request';

// TODO: 파일 분리 
export const FETCH_API = {
    "DOCUMENT.FILE_GET_LIST": '/elastic/documents',
    "DOCUMENT.FILE_GET_ONE": '/elastic/document',
    "DOCUMENT.FILE.REGISTRATION_CREATE": "/doc/put",
    "DOCUMENT.FILE_DELETE_MANY": '/doc/delete',
    "DOCUMENT.FILE.TAGS_CREATE": '/doc/keyword',
    "DOCUMENT.FILE.DEIDENTIFICATION_CREATE": "http://demo.wesome.co.kr/blind/upload",
    "DOCUMENT.IMAGE.DEIDENTIFICATION_CREATE": "/image/personalDeIdentificaton",
    "DOCUMENT.FILE.DEIDENTIFICATION_DOWNLOAD": "/doc/fileDeIdentificatonDownload",
    "DOCUMENT.IMAGE.FINGERPRINT.DEIDENTIFICATION_CREATE": "http://115.68.223.78:5000/fingerprint/deIdentification",
    "DOCUMENT.GRAPH.VISUALIZATION.INIT_GET_ONE": "/neo4j/documents",
    "DOCUMENT.GRAPH.VISUALIZATION.ADD_GET_ONE": "/neo4j/document",
    "DOCUMENT.GRAPH.VISUALIZATION.TYPE_GET_ONE": "/neo4j/document/link",
};

// TODO: takeLatest/takeEvery
export function* handleFetch(action) {
    const {
        type,
        payload,
        meta: { fetch: fetchType, popup, multipart, fetchMethod, menu, loading, onSuccess, onFailure, ...meta },
    } = action;

    const displayType = popup ? 'POPUP_' : '';

    try {
        yield put({ 
            type: `${displayType}FETCH_START`,
            meta: {
                menu,
                loading,
            },
        });
        const httpMethod = fetchMethod ? fetchMethod : 'get';
        let response = yield call(request, FETCH_API[`${menu}_${fetchType}`], { method:httpMethod, data:payload.params, multipart });
        console.log(response);
        yield put({
            type: `${type}_SUCCESS`,
            payload: menu === "DOCUMENT.FILE.DEIDENTIFICATION" ? response.data : response.data.data,
            requestPayload: payload,
            meta: {
                menu,
                popup,
                ...meta,
                ...onSuccess,
            },
        });
        yield put({ 
            type: `${displayType}FETCH_END`,
            meta: {
                menu,
                loading,
            },
        });

    } catch (error) {
        console.log("error:", error)
        // 인증 관련 에러 (다른 곳에서 로그아웃되었거나 자동로그아웃된 경우)
        if( error.status === 401 || error.status === 420 ) {
            console.log("error.status: ", error.status);
        
        // 기타 에러 
        } else {

            yield put({
                type: `${type}_FAILURE`,
                error: error,
                meta: {
                    menu,
                    popup,
                    ...meta,
                    ...onFailure,
                },
            });
            
        }
        yield put({ 
            type: `${displayType}FETCH_ERROR`,
            meta: {
                menu,
                loading,
            }, 
        });

    } finally {
        console.log("fetch.js >>> finally!!!!!!");
        if (yield cancelled()) {
            console.log("fetch.js >>> cancelled!!!!!!");
            yield put({ 
                type: `${displayType}FETCH_CANCEL`,
                meta: {
                    menu,
                    loading,
                },
            });
        }
    }
        
}

export default function* message() {
    yield takeEvery(
        action => action.meta && action.meta.fetch,
        handleFetch
    );
}

// export const takeFetchAction = action => action.meta && action.meta.fetch;
// export default function* message() {
//     yield all([
//         takeEvery(takeFetchAction, handleFetch),
//     ]);
// };